import { Col, Form, Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputNumberComponent from 'components/atoms/InputNumberComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import SaveButtonComponent from 'components/molecules/SaveButtonComponent';

import checkLeiApi from 'services/akcionar/emise/checkLei';
import identifikaceEmitenta, { IIdentifikaceEmitenta } from 'services/akcionar/emise/identifikaceEmitenta';
import { IRozcestnikData } from 'services/akcionar/emise/rozcestnikISIN';
import { isinGetNaceList } from 'services/akcionar/emise/zadostISIN';

import { EAnoNe } from 'enums/anoNe';
import { EEmitentZadaOpridISIN } from 'enums/isin/emitentZadaOpridISIN';
import { EEvidenceCp } from 'enums/isin/evidenceCp';
import { naceRegExp } from 'enums/regExp';

import anoNe from 'data/codebooks/anoNeSelect';
import { leiElfKodySelect } from 'data/codebooks/lei/leiElfKodySelect';

import { _getKeyValue_ } from 'utils/getObjectKeyValue';
import { dicValidation } from 'utils/validations/dicValidation';
import dveDesetinneMistaValidation from 'utils/validations/dveDesetinneMistaValidation';
import { emailValidation } from 'utils/validations/emailValidation';
import { leiValidation } from 'utils/validations/leiValidation';
import { phoneValidation } from 'utils/validations/phoneValidation';
import { procentaValidation } from 'utils/validations/procentaValidation';

export interface IRozcestnikInput {
    emitentje?: string;
    evidencecp?: EEvidenceCp;
    podobacp?: string;
}

interface IIdentifikaceEmitentaNovy {
    prevStep: () => void;
    rozcestnikData?: IRozcestnikData['spolecnost'];
    rozcestnikInput?: IRozcestnikInput;
    setIdentifikacePutData: React.Dispatch<React.SetStateAction<IIdentifikaceEmitenta | undefined>>;
    identifikacePutData?: IIdentifikaceEmitenta;
    modalMessage?: string;
    zadostID?: number;
    setModalMessage: (val: string) => void;
    // rozpracovanaZadost: boolean;
    isRegistration?: boolean;
}

const IdentifikaceEmitentaNovy: React.FC<IIdentifikaceEmitentaNovy> = ({
    modalMessage,
    prevStep,
    zadostID,
    rozcestnikData,
    rozcestnikInput,
    setIdentifikacePutData,
    identifikacePutData,
    setModalMessage,
    //    rozpracovanaZadost,
    isRegistration
}) => {
    const { isin, cisStaty, cisMeny, profily } = useContext(Context);
    const [form] = Form.useForm();
    const setForceRerender = useState<boolean>(false)[1];
    const [saving, setSaving] = useState<boolean>(false);
    const [saveModalMessage, setSaveModalMessage] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [leiError, setLeiError] = useState<boolean>(false);
    const [naceData, setNaceData] = useState<{ labelcz: string; value: string }[]>();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (value: any) => {
        const finishData: IIdentifikaceEmitenta = {
            ...isin,
            ...rozcestnikData,
            ...identifikacePutData,
            ...rozcestnikInput,
            ...value,
            ...(value.bankspojeni && {
                bankspojeni: value.bankspojeni.split(' ').join('')
            }),
            madic: value.madic === EAnoNe.ANO,
            kost: value.stat,
            ...(naceData && {
                nacepopis:
                    // rozcestnikInput?.podobacp !== EEmitentZadaOpridISIN.LISTINNY &&
                    naceData.length && value.nace
                        ? naceData?.filter(e => value.nace == e.value)[0].labelcz
                        : value.nacepopis
            })
        };

        delete finishData.idZadosti;
        delete finishData.stav;
        if (value.madic === EAnoNe.NE) {
            delete finishData.dic;
        }
        !saving && setIdentifikacePutData(finishData);
        saving &&
            identifikaceEmitenta(
                'PUT',
                zadostID ? zadostID : 0,
                finishData,
                isRegistration ? 'Registration' : undefined
            )
                .then(() => {
                    setSaveModalMessage('ULOZENI_DAT_200');
                })
                .catch(() => setSaveModalMessage('CHYBA_ULOZENI_DAT'));
        setSaving(false);
    };

    useEffect(() => {
        saving && onFinish(form.getFieldsValue());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saving]);

    useEffect(() => {
        if (rozcestnikData?.lei || identifikacePutData?.lei || isin?.lei) {
            setLoading(true);
            checkLeiApi(rozcestnikData?.lei || identifikacePutData?.lei || isin?.lei || '')
                .then(response => {
                    (response.stav === 'RETIRED' ||
                        response.stav === 'LAPSED' ||
                        response.stav === 'ANNULLED' ||
                        response.stav === 'CANCELLED') &&
                        setLeiError(true);
                })
                .finally(() => setLoading(false));
        }
        ((identifikacePutData && typeof identifikacePutData.madic === 'boolean' && identifikacePutData.madic) ||
            (isin && typeof isin.madic === 'boolean' && isin.madic)) &&
            form.setFieldsValue({
                madic: EAnoNe.ANO
            });
        isinGetNaceList().then(
            resp =>
                resp.nacelist.length &&
                setNaceData(
                    resp.nacelist.map(e => {
                        return {
                            labelcz: e.nacepopis,
                            value: e.nace
                        };
                    })
                )
        );
        setForceRerender(val => !val);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const rerender = () => {
        setForceRerender(val => !val);
    };

    console.log(rozcestnikInput, rozcestnikData);

    return (
        <LoadingWrapper loading={loading}>
            <FormWrapper outForm={form} onFinish={onFinish} preserve={false}>
                <SaveButtonComponent
                    onClick={() => {
                        setSaving(true);
                    }}
                    modalText={saveModalMessage}
                    onModalClose={() => setSaveModalMessage('')}
                    id="saveBtn"
                />
                {isRegistration && (
                    <InputComponent
                        label={'ISIN_JINA_JURISDIKCE'}
                        name="cval"
                        type="text"
                        initialValue={rozcestnikData?.cval || identifikacePutData?.cval || isin?.cval}
                        capitalize={true}
                        disabled={true}
                    />
                )}
                <InputComponent
                    disabled={true}
                    label="IDENTIFIKACNI_CISLO"
                    name="idmb"
                    initialValue={rozcestnikData?.idmb || identifikacePutData?.idmb || isin?.idmb}
                    type="text"
                    maxLength={10}
                />

                <InputComponent
                    disabled={!!rozcestnikData?.nazev || !!identifikacePutData?.nazev || !!isin?.nazev}
                    label="ISIN_IDENTIFIKACE_FIRMA"
                    name="nazev"
                    initialValue={rozcestnikData?.nazev || identifikacePutData?.nazev || isin?.nazev}
                    type="text"
                    maxLength={500}
                />
                <InputComponent
                    disabled={true}
                    label="LEI_CELE"
                    name="lei"
                    initialValue={rozcestnikData?.lei || identifikacePutData?.lei || isin?.lei}
                    extramessage={leiError ? 'CHECK_LEI_MATKASLEI_NEPLATNE_LEI' : ''}
                    maxLength={20}
                    type="text"
                    rules={leiValidation()}
                />
                <InputComponent
                    label="ISIN_IDENTIFIKACE_PRAVNI_FORMA"
                    name="pravniforma"
                    initialValue={
                        rozcestnikData?.pravniforma ||
                        identifikacePutData?.pravniforma ||
                        isin?.pravniforma ||
                        (rozcestnikData?.forma &&
                            (() => {
                                const elfVals = _getKeyValue_(
                                    rozcestnikData?.stat || identifikacePutData?.stat || isin?.stat || 'SK'
                                )(leiElfKodySelect)
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .filter((u: any) => u.value === rozcestnikData?.forma);
                                console.log(elfVals);
                                return `${elfVals.length > 0 && [elfVals[0].labelcz]}`;
                            })())
                    }
                    maxLength={500}
                    type="text"
                    disabled={isRegistration}
                />
                <Title level={5} text="ISIN_IDENTIFIKACE_ADRESA_SIDLA" dividerTitle={true} />
                <InputComponent
                    label="ULICE_CP"
                    name="adma"
                    initialValue={rozcestnikData?.adma || identifikacePutData?.adma || isin?.adma}
                    type="text"
                    maxLength={50}
                />
                <InputComponent
                    label="MESTO"
                    name="mema"
                    initialValue={rozcestnikData?.mema || identifikacePutData?.mema || isin?.mema}
                    type="text"
                    maxLength={50}
                />
                <InputComponent
                    label="PSC"
                    name="pscm"
                    initialValue={rozcestnikData?.pscm || identifikacePutData?.pscm || isin?.pscm}
                    maxLength={10}
                    type="text"
                />
                <SelectComponent
                    disabled={true}
                    name="stat"
                    labelParagraph="STAT_SIDLA"
                    isFormItem={true}
                    defaultValue={rozcestnikData?.stat || identifikacePutData?.stat || isin?.stat}
                    data={cisStaty}
                />

                <Title level={5} text="DOPLNUJICI_INFORMACE" dividerTitle={true} />
                <InputNumberComponent
                    maxLength={19}
                    name="kapital"
                    label="ISIN_IDENTIFIKACE_KAPITAL"
                    rules={dveDesetinneMistaValidation(false)}
                    initialValue={
                        typeof identifikacePutData?.kapital === 'number' ? identifikacePutData?.kapital : isin?.kapital
                    }
                />

                <SelectComponent
                    name="mena"
                    labelParagraph="ISIN_IDENTIFIKACE_MENA"
                    isFormItem={true}
                    data={cisMeny}
                    defaultValue={identifikacePutData?.mena || isin?.mena}
                />
                <InputNumberComponent
                    label="ISIN_IDENTIFIKACE_SPLACENO"
                    name="splaceno"
                    rules={procentaValidation()}
                    initialValue={identifikacePutData?.splaceno || isin?.splaceno || undefined}
                    maxLength={5}
                />

                <SelectComponent
                    name="madic"
                    labelParagraph="ISIN_IDENTIFIKACE_PLATCE"
                    isFormItem={true}
                    data={anoNe}
                    onChange={() => {
                        form.resetFields(['dic']);
                        rerender();
                    }}
                    defaultValue={
                        identifikacePutData && typeof identifikacePutData.madic === 'boolean'
                            ? identifikacePutData.madic
                                ? EAnoNe.ANO
                                : EAnoNe.NE
                            : isin && typeof isin.madic === 'boolean'
                              ? isin.madic
                                  ? EAnoNe.ANO
                                  : EAnoNe.NE
                              : undefined
                    }
                />
                {form.getFieldValue('madic') === EAnoNe.ANO && (
                    <InputComponent
                        initialValue={isin?.dic || identifikacePutData?.dic}
                        label="ISIN_IDENTIFIKACE_DIC"
                        name="dic"
                        maxLength={14}
                        rules={dicValidation()}
                    />
                )}
                {rozcestnikInput?.podobacp !== EEmitentZadaOpridISIN.LISTINNY && (
                    <>
                        {/* <InputComponent
                            label="IBAN"
                            infoTooltipText="ISIN_IDENTIFIKACE_VLASTNIK_HELP"
                            name="bankspojeni"
                            maxLength={34}
                            rules={ibanValidation()}
                            initialValue={identifikacePutData?.bankspojeni || isin?.bankspojeni}
                        /> */}
                        <SelectComponent
                            name="zemesidla"
                            labelParagraph="ZEME_SIDLA_VLASTNIKA_EMITENTA"
                            isFormItem={true}
                            data={cisStaty}
                            defaultValue={identifikacePutData?.zemesidla || isin?.zemesidla}
                        />
                    </>
                )}
                {naceData ? (
                    <SelectComponent
                        isFormItem={true}
                        name="nace"
                        defaultValue={identifikacePutData?.nace || isin?.nace}
                        labelParagraph="NACE"
                        data={naceData.map(e => {
                            return {
                                value: e.value,
                                labelcz: e.value + ' - ' + e.labelcz
                            };
                        })}
                    />
                ) : (
                    <InputComponent
                        label={
                            isRegistration && (rozcestnikData?.stat || identifikacePutData?.stat || isin?.stat) === 'SK'
                                ? 'SK_NACE'
                                : 'CZ_NACE'
                        }
                        infoTooltipText={
                            isRegistration && (rozcestnikData?.stat || identifikacePutData?.stat || isin?.stat) === 'SK'
                                ? undefined
                                : 'FORMULARE_NACE_TOOLTIP'
                        }
                        maxLength={17}
                        name="nace"
                        initialValue={identifikacePutData?.nace || isin?.nace}
                        rules={
                            isRegistration && (rozcestnikData?.stat || identifikacePutData?.stat || isin?.stat) === 'SK'
                                ? undefined
                                : [
                                      () => ({
                                          validator(_, value: string) {
                                              if (!value || naceRegExp.test(value)) return Promise.resolve();
                                              return Promise.reject(<TranslateText>NEVALIDNI_NACE</TranslateText>);
                                          }
                                      })
                                  ]
                        }
                    />
                )}
                <InputComponent
                    label="ISIN_IDENTIFIKACE_EMAIL_FAKTURY"
                    infoTooltipText="ISIN_IDENTIFIKACE_EMAIL_FAKTURY_HELP"
                    name="email"
                    maxLength={128}
                    initialValue={identifikacePutData?.email || isin?.email}
                    rules={emailValidation()}
                />
                <InputComponent
                    label="ISIN_IDENTIFIKACE_EMAIL_OSOBY"
                    name="emailkont"
                    maxLength={128}
                    initialValue={profily?.email || identifikacePutData?.emailkont || isin?.emailkont}
                    rules={emailValidation()}
                    disabled={!!profily?.email}
                />
                <InputComponent
                    label="ISIN_IDENTIFIKACE_TELEFON"
                    name="telefon"
                    maxLength={17}
                    initialValue={profily?.telefon1 || identifikacePutData?.telefon || isin?.telefon}
                    rules={phoneValidation()}
                    disabled={!!profily?.telefon1}
                />
                <Row className="button-row">
                    {!isin && !isRegistration && (
                        <Col>
                            <ButtonComponent
                                buttontext="ZPET"
                                onClick={() => prevStep()}
                                type="default"
                                id="isinZpetbtn"
                            />
                        </Col>
                    )}
                    <Col>
                        <ButtonComponent
                            buttontext="POKRACOVAT"
                            onClick={() => form.submit()}
                            disabled={leiError}
                            id="isinPokracovatBtn"
                        />
                    </Col>
                </Row>
            </FormWrapper>
            <Modal
                title={<TranslateText>{'VYJADRENI_CDCP'}</TranslateText>}
                open={!!modalMessage}
                onCancel={() => setModalMessage('')}
                afterClose={() => {
                    setModalMessage('');
                }}
                footer={
                    <Row className="button-row-modal">
                        <ButtonComponent
                            style={{
                                marginTop: 20
                            }}
                            id="isinZavritBtn"
                            buttontext="ZAVRIT"
                            onClick={() => {
                                setModalMessage('');
                            }}
                        />
                    </Row>
                }
            >
                <Row>
                    <Paragraph text={modalMessage ? modalMessage : ''} />
                </Row>
            </Modal>
        </LoadingWrapper>
    );
};

export default IdentifikaceEmitentaNovy;
